<div class="general-info-card">
    <div class="medication-header">
        <div class="status-indicators">
            <span class="birds-count">{{
                (placement?.qty ?? 0) + ' birds'
            }}</span>
            <span class="age-indicator"
                >Age: {{ medication?.age || ' -' }}</span
            >
        </div>
        <div class="date-time">
            {{ medication?.applicationDate | date: 'yyyy-MM-dd' }} |
            {{ medication?.applicationDate | date: 'HH:mm' }}
        </div>
    </div>

    <div class="medication-grid">
        <div class="grid-item">
            <div class="field-label">Medication Name:</div>
            <div class="field-value">
                {{ medicationName || '-' }}
            </div>
        </div>
        <div class="grid-item">
            <div class="field-label">Indication:</div>
            <div class="field-value">
                {{ medication?.classificationName || '-' }}
            </div>
        </div>

        <div class="grid-item">
            <div class="field-label">Application Type:</div>
            <div class="field-value">
                {{ medication?.typeName || '-' }}
            </div>
        </div>

        <div class="grid-item">
            <div class="field-label">Batch:</div>
            <div class="field-value">{{ batch || '-' }}</div>
        </div>

        <div class="grid-item">
            <div class="field-label">Quantity:</div>
            <div class="field-value">
                {{ medication?.dose || '-' }} {{ dosageUnit || '-' }}
            </div>
        </div>

         <div class="grid-item">
            <div class="field-label">Medicated Birds:</div>
            <div class="field-value">
                {{ medication?.medicatedBirds || '-' }} 
            </div>
        </div>

        <div class="grid-item">
            <div class="field-label">Duration:</div>
            <div class="field-value">
                {{ medication?.duration || '-' }}
                {{ medication?.duration === 1 ? 'day' : 'days' }}
            </div>
        </div>

        <div class="grid-item">
            <div class="field-label">Supplier:</div>
            <div class="field-value">
                {{ supplier || '-' }}
            </div>
        </div>
    </div>

    <div class="medication-notes">
        <div class="field-label">Notes:</div>
        <div class="field-value">{{ medication?.notes || '-' }}</div>
    </div>
</div>
